<template>
    <div class="flex-form__inline">
        <content-editable
            :class="getInvalidClass('targetValue')"
            :value="dataNew.targetValue"
            @input="onInput"
        />
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'condition-operator-greater-less',
    mixins: [eventDataMixin],

    computed: {
        schema() {
            return {
                targetValue: {
                    type: String,
                    default: '',
                    required: true,
                },
            };
        },
    },

    methods: {
        onInput(value) {
            this.dataNew.targetValue = value;
        },
    },
};
</script>
